import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "admin-config-branches" }
const _hoisted_2 = { class: "loader" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-spinner fa-pulse" })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "add-new" }

import AdminConfigBranchesBranch from '@/components/AdminConfigBranches/AdminConfigBranchesBranch.vue';
import {
  computed, onMounted, ref,
} from 'vue';
import ProductCategoryInterface from '@/interfaces/ProductCategoryInterface';
import BranchConfigurationInterface from '@/interfaces/BranchConfigurationInterface';
import IoProductAPI from '@/api/IoProductAPI';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConfigBranches',
  setup(__props) {

const hiddenBranchSettingsField = document.querySelector('[name="io_branch_settings"]') as HTMLInputElement;
const defaultSettings = JSON.parse(hiddenBranchSettingsField?.value || '[]') as BranchConfigurationInterface[];
if (hiddenBranchSettingsField) {
  hiddenBranchSettingsField.remove();
}

const configuredBranches = ref<BranchConfigurationInterface[]>(defaultSettings.map((configuredBranch) => {
  const updatedBranch = configuredBranch;

  if (!updatedBranch.customColor) {
    updatedBranch.customColor = {
      primary: undefined,
      secondary: undefined,
    };
  }

  if (!updatedBranch.images) {
    updatedBranch.images = {
      priceshow: undefined,
    };
  }

  return updatedBranch;
}));
const categories = ref<ProductCategoryInterface[]>([]);
const branchConfigJson = computed(() => JSON.stringify(configuredBranches.value));

const isFetching = ref(true);
onMounted(() => {
  IoProductAPI.getCategories(true).then((fetchedCategories) => {
    categories.value = fetchedCategories;
  }).finally(() => {
    isFetching.value = false;
  });
});

const deleteBranch = (index: number) => {
  const branchToDelete = configuredBranches.value[index];

  if (!branchToDelete) return;

  configuredBranches.value.splice(index, 1);
};

const addNew = () => {
  configuredBranches.value.push({
    id: Date.now(),
    name: '',
    isUrl: false,
    url: undefined,
    customIcon: undefined,
    slug: '',
    iconOrImage: undefined,
    customIconOrImage: undefined,
    category: undefined,
    dynamicTariffs: 'disabled',
    subcategories: [],
    subcategoriesExcept: [],
    customColor: {
      primary: undefined,
      secondary: undefined,
    },
    images: {
      priceshow: undefined,
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_4, 512), [
      [_vShow, isFetching.value]
    ]),
    _createElementVNode("input", {
      type: "hidden",
      style: {"opacity":"0","visibility":"hidden","pointer-events":"none","position":"absolute"},
      value: branchConfigJson.value,
      name: "io_branch_settings"
    }, null, 8, _hoisted_5),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configuredBranches.value, (configuredBranch, inx) => {
      return (_openBlock(), _createBlock(AdminConfigBranchesBranch, {
        key: `configured-branch--${configuredBranch.id}`,
        index: inx,
        "num-branches": configuredBranches.value.length,
        categories: categories.value,
        modelValue: configuredBranches.value[inx],
        "onUpdate:modelValue": ($event: any) => ((configuredBranches.value[inx]) = $event),
        onDelete: deleteBranch
      }, null, 8, ["index", "num-branches", "categories", "modelValue", "onUpdate:modelValue"]))
    }), 128)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("input", {
        type: "button",
        class: "button button-primary",
        value: "Neue Sparte anlegen",
        onClick: _withModifiers(addNew, ["prevent"])
      })
    ])
  ]))
}
}

})